<template>
  <div>
    <el-table :data="activityList" border size="small" style="width: 1301px">
      <el-table-column prop="zoneId" label="分区" align="center" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.zoneId == 0" style="">全区</span>
          <span v-else style="">{{ scope.row.zoneId }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="confId"
        label="活动配置ID"
        align="center"
        width="150"
      >
      </el-table-column>

      <el-table-column prop="key" label="活动模板" align="center" width="120">
      </el-table-column>

      <el-table-column
        prop="startAt"
        label="活动开始时间"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ ms2ymdhm(Number(scope.row.startAt)) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="endAt"
        label="活动结束时间"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ ms2ymdhm(Number(scope.row.endAt)) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="playStartAt"
        label="玩法开始时间"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ ms2ymdhm(Number(scope.row.playStartAt)) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="playEndAt"
        label="玩法结束时间"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ ms2ymdhm(Number(scope.row.playEndAt)) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="isOpen"
        label="活动进行中"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.isOpen" style="color: red">否</span>
          <span v-if="scope.row.isOpen" style="color: green">是</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="isSettle"
        label="玩法已结算"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.isSettle" style="color: red">否</span>
          <span v-if="scope.row.isSettle" style="color: green">是</span>
        </template>
      </el-table-column>

      <el-table-column label="内容" align="center" width="150">
        <template slot-scope="scope">
          <el-popover
            v-if="scope.row.context != 'null' && scope.row.context != '{}'"
            placement="right"
            trigger="hover"
            width="600"
          >
            <div style="margin-top: 5px">
              <el-input
                type="textarea"
                rows="15"
                :value="string2yaml(scope.row.context)"
                readonly
                placeholder=""
              >
              </el-input>
            </div>

            <el-button slot="reference" size="small" icon="el-icon-view"
              >查看</el-button
            >
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-button
            type="primary"
            round
            size="mini"
            @click="openSettingActivityDialog(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 线上活动实例框 -->
    <SettingActivityDialog
      v-if="shouldSettingActivityDialogVisible"
      @close="onSettingActivityDialogClosed()"
      :value="valueForSettingActivityDialog"
    ></SettingActivityDialog>
  </div>
</template>
  
  <script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const yaml = require("js-yaml");

import SettingActivityDialog from "./SettingActivityDialog";

export default {
  data() {
    return {
      shouldSettingActivityDialogVisible: false, // 编辑线上活动弹出框是否应该显示出来
      valueForSettingActivityDialog: null, // 要传递给线上活动弹出框的数据
      activityList: [], // 列表里展示的数据
    };
  },

  created() {
    this.loadActivityList();
  },

  components: {
    SettingActivityDialog,
  },

  methods: {
    /**
     * 拉取活动实例集合
     */
    async loadActivityList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getAllActivitiesInActive`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      this.activityList = listInResponse;
    },

    /**
     * 打开编辑活动实例对话框
     */
    async openSettingActivityDialog(entry) {
      this.shouldSettingActivityDialogVisible = true;
      this.valueForSettingActivityDialog = {
        info: entry,
      };
    },

    /**
     * 编辑活动实例对话框关闭了
     */
    async onSettingActivityDialogClosed() {
      this.shouldSettingActivityDialogVisible = false;
      // 重新拉取线上活动集合
      return this.loadActivityList();
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },

    string2yaml(obj) {
      let yamlStr;
      yaml.loadAll(obj, function (doc) {
        yamlStr = yaml.dump(doc, {
          styles: {
            "!!null": "canonical",
          },
          sortKeys: true,
        });
      });
      return yamlStr;
    },
    formatCode(obj) {
      return JSON.stringify(obj, null, "    ");
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}

.link-button {
  padding-left: 10px;
  color: rgb(37, 148, 240);
  cursor: pointer;
}

/deep/ .el-table__row td {
  padding: 3px 0;
}

/deep/ .el-table .cell {
  line-height: 18px;
}
</style>

  